export default __webpack_public_path__ + "static/media/pbx.afa48eb4.svg";